var getCurrentQuestionAnswer = function (_a) {
    var userAnswers = _a.userAnswers, currentQuestion = _a.currentQuestion;
    return userAnswers.find(function (userAnswer) { return (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.id) === (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id); });
};
export default getCurrentQuestionAnswer;
//# sourceMappingURL=getCurrentQuestionAnswer.js.map